module.exports = __webpack_public_path__ + "img/instagram-footer-icon.54a19e6.png";